import React from "react";
import { Award, Compass, Heart, Users } from "lucide-react";

export default function About() {
  const stats = [
    { value: "400+", label: "EVENIMENTE REUȘITE" },
    { value: "300", label: "CAPACITATE OASPEȚI" },
    { value: "100%", label: "CLIENȚI FERICIȚI" },
    { value: "10+", label: "ANI EXPERIENȚĂ" }
  ];

  return (
    <section 
      id="despre-noi"
      data-testid="about-section"
      className="py-24 sm:py-32 bg-[#121212] overflow-hidden relative"
    >
      {/* Decorative luxury lines or details */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full filter blur-3xl -z-10" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-black rounded-full filter blur-3xl -z-10" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-center">
          
          {/* Text Presentation */}
          <div className="lg:col-span-6 space-y-8">
            <div className="space-y-4">
              <span className="text-xs font-semibold tracking-[0.3em] text-[#D4AF37] uppercase">
                O SPUNEM CU MÂNDRIE
              </span>
              <h2 
                data-testid="about-title"
                className="font-serif-lux text-3xl sm:text-5xl text-white font-medium tracking-tight leading-tight"
              >
                Elysium Events — Unde eleganța întâlnește momentele tale de vis
              </h2>
            </div>

            <p 
              data-testid="about-description"
              className="text-base sm:text-lg text-white/80 leading-relaxed font-light"
            >
              La Elysium Events, fiecare detaliu contează. Oferim un cadru elegant și servicii de înaltă calitate pentru evenimente care rămân în sufletul invitaților. Ne ghidăm după excelență și rafinament, transformând fiecare nuntă, botez sau petrecere corporate într-o operă de artă.
            </p>

            <blockquote className="border-l-2 border-[#D4AF37] pl-6 py-2 italic text-lg text-[#F3E5D8]/90 bg-white/[0.02]">
              „Locul unde fiecare eveniment devine o amintire de neuitat”
            </blockquote>

            {/* Micro bento grid features inside about */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-4">
              <div className="flex items-start space-x-3">
                <div className="p-2 bg-black border border-[#D4AF37]/20 text-[#D4AF37] mt-1">
                  <Heart size={16} />
                </div>
                <div>
                  <h4 className="text-sm font-semibold tracking-wider text-white uppercase">Pasiune și Devotament</h4>
                  <p className="text-xs text-white/60 mt-1">Suntem alături de tine în planificarea fiecărui pas, oferindu-ți consultanță dedicată.</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="p-2 bg-black border border-[#D4AF37]/20 text-[#D4AF37] mt-1">
                  <Award size={16} />
                </div>
                <div>
                  <h4 className="text-sm font-semibold tracking-wider text-white uppercase">Calitate Ultra-Premium</h4>
                  <p className="text-xs text-white/60 mt-1">De la preparatele gastronomice până la sistemele de sunet și lumini, totul este la nivel de top.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Luxury Visual Layout (Asymmetric Bento/Grid of pictures) */}
          <div className="lg:col-span-6 grid grid-cols-12 gap-4 h-[450px] sm:h-[550px] relative">
            <div className="col-span-8 h-full overflow-hidden border border-[#D4AF37]/10">
              <img 
                src="https://customer-assets.emergentagent.com/job_luxury-events-sibiu/artifacts/6ej9lec9_5C615569-3220-4EAD-A3A2-26E7CB1F8B5F.png" 
                alt="Sala de evenimente Elysium Events Sibiu" 
                className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="col-span-4 grid grid-rows-2 gap-4 h-full">
              <div className="h-full overflow-hidden border border-[#D4AF37]/10">
                <img 
                  src="https://customer-assets.emergentagent.com/job_luxury-events-sibiu/artifacts/z39h29j3_IMG_8876.jpeg" 
                  alt="Aranjament masă elegant Elysium Events" 
                  className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="h-full overflow-hidden border border-[#D4AF37]/10">
                <img 
                  src="https://customer-assets.emergentagent.com/job_luxury-events-sibiu/artifacts/wog3bf6m_6BBAA16D-AD7B-409A-8AEA-5AF8CFAA0883.png" 
                  alt="Prezidiu cu perete floral Elysium Events" 
                  className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-700"
                />
              </div>
            </div>
          </div>

        </div>

        {/* Stats strip */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pt-20 border-t border-white/10 mt-20 text-center">
          {stats.map((stat, i) => (
            <div key={i} className="space-y-2">
              <div className="font-serif-lux text-3xl sm:text-5xl text-[#D4AF37] font-semibold">{stat.value}</div>
              <div className="text-[10px] tracking-[0.25em] text-white/60 uppercase font-medium">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
